import { TComment } from "apiTypes";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import useTranslation from "next-translate/useTranslation";
import { useState } from "react";
import { toast } from "react-toastify";
import { arrayFromNum } from "utils/arrayFromNum";
import { useInfinitePagination } from "../../customHooks/useInfinitPagination";
import { postData } from "../../utils/postData";
import AddEditCommentModal from "../ReuseableCompos/CommentsForm/AddEditCommentModal";
import Comment from "../ReuseableCompos/CommentsForm/Comment";
import EditDeleteCommentDropdown from "../ReuseableCompos/CommentsForm/EditDeleteCommentDropdown";
import CustomInfinitScroll from "../ReuseableCompos/CustomInfinitScroll";
import CommentSkeleton from "../Skeletons/CommentSkeleton";
type Props = {
  singleBlogURL: string;
  commentCount: number;
  setReactingCounts: any;
  showAddEditCommentModal: boolean;
  handleCloseAddEditCommentModal: () => void;
  handleShowAddEditCommentModal: () => void;
};
const CommentContainer = ({
  singleBlogURL,
  setReactingCounts,
  showAddEditCommentModal,
  handleCloseAddEditCommentModal,
  handleShowAddEditCommentModal,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const { hasReachedEnd, mutate, formattedData, getMoreData, error } =
    useInfinitePagination<TComment>(
      `${singleBlogURL}/comments`,
      {
        revalidateOnFocus: true,
        revalidateFirstPage: true,
      },
      null,
      false
    );

  const { t } = useTranslation("common");

  const onCommentSubmit = async ({ comment }) => {
    setIsLoading(true);
    try {
      const res = await postData(`${singleBlogURL}/comments`, {
        content: comment,
      });
      await mutate();

      setReactingCounts((prev) => ({
        ...prev,
        comments_count: formattedData.length + 1,
      }));
      handleCloseAddEditCommentModal();
      if (res.data?.error) {
        toast.error(res.data?.error);
        return;
      }

      toast.success(t(`comment_added`));
    } catch (err) {
      if (err?.response?.data.status === "Unauthorized") {
        toast.error(err.response.data.status);

        return;
      }

      toast.error(err?.message);

      toast.error(err.response?.data.error?.code);
    }
    setIsLoading(false);
  };
  if (!error && !formattedData) {
    return (
      <>
        {arrayFromNum(4).map((item) => (
          <CommentSkeleton key={item} />
        ))}
      </>
    );
  }

  return (
    <>
      {!(formattedData.length <= 0) && <div className="border-top py-3" />}

      <CustomInfinitScroll
        getMoreData={getMoreData}
        dataLength={formattedData?.length}
        hasMore={!hasReachedEnd}
        no100vh
        customLoader={arrayFromNum(4).map((item) => (
          <CommentSkeleton key={item} />
        ))}
      >
        {formattedData?.map((comment, idx) => {
          const isLast = idx === formattedData.length - 1;
          return (
            <Comment data={comment} key={comment?.id} isLast={isLast}>
              <EditDeleteCommentDropdown
                setReactingCounts={setReactingCounts}
                mutate={mutate}
                formattedData={formattedData}
                id={comment?.id}
              />
            </Comment>
          );
        })}
      </CustomInfinitScroll>
      {formattedData.length ? (
        <div className="mb-3 d-flex w-100 justify-content-center align-items-center">
          <MolhamButton
            id="blog-add-comment-btn"
            label={t("add_comment")}
            onClick={handleShowAddEditCommentModal}
            endIcon="fe-plus"
          />
        </div>
      ) : null}
      <AddEditCommentModal
        showAddEditCommentModal={showAddEditCommentModal}
        handleCloseAddEditCommentModal={handleCloseAddEditCommentModal}
        onEditCommentSubmit={(data) => onCommentSubmit(data)}
        isLoading={isLoading}
        content={null}
        isAdd
      />
    </>
  );
};

export default CommentContainer;
